/*
 * @Author: cn1994
 * @Date: 2025-04-01 14:06:02
 * @LastEditors: cn1994
 * @LastEditTime: 2025-04-01 16:37:50
 * @Description: file content
 */
import { useBaseStore } from '@/stores/base'

export default {
  data() {
    const { userInfo } = useBaseStore()
    return {
      userInfo
    }
  },
  computed: {
    // 是否是老师
    isGroupTeacher() {
      return this.userInfo.role === 'groupTeacher'
    },
    // 是否是学管师
    isGroupHeadTeacher() {
      return this.userInfo.role === 'groupHeadTeacher'
    },
    // 是否是管理员
    isGroupAdmin() {
      return this.userInfo.role === 'groupAdmin' && this.userInfo.adminRole !== 0
    }
  }
}
